<script>
    import External from "./External.svelte";
    export let width = 420;
</script>

<External url={"/callcenterrep.svg"} width={156.77} height={156.77} maxWidth={width}/>